import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=2c7fade2&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=ts"
export * from "./PlanDetails.vue?vue&type=script&lang=ts"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=2c7fade2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7fade2",
  null
  
)

export default component.exports